import Layout from '@/views/layout/Layout'

const AuthorityRouter = [
  {
    path: "/Authority",
    component: Layout,
    redirect: "authorityLevel", // 重定向到默认子路由
    children: [
      {
        path: "authorityLevel",
        component: () => import("@/views/Authority/authorityLevel/index"),
        name: "authorityLevel",
        meta: {
          title: "authorityLevel",
          noCache: true,
        },
      },
        {
        path: "user",
        component: () => import("@/views/Authority/user/index"),
        name: "user",
        meta: {
          title: "user",
          noCache: true,
        },
      },
         {
        path: "userImport",
        component: () => import("@/views/Authority/userImport/index"),
        name: "userImport",
        meta: {
          title: "userImport",
          noCache: true,
        },
        },
      {
        path: "userAuthority", 
        component: () => import("@/views/Authority/userAuthority/index"),
        name: "userAuthority",
        meta: {
          title: "userAuthority", 
          noCache: true,
        },
      },
      {
        path: "userLeaveMessage", 
        component: () => import("@/views/Authority/userLeaveMessage/index"),
        name: "userLeaveMessage",
        meta: {
          title: "userLeaveMessage", 
          noCache: true,
        },
      },
      {
        path: "upLoad",
        component: () => import("@/views/Authority/upLoad/index"),
        name: "upLoad",
        meta: {
          title: "upLoad",
          noCache: true,
        },
      },
      {
        path: "SGMupLoad",
        component: () => import("@/views/Authority/SGMupLoad/index"),
        name: "upLoad",
        meta: {
          title: "upLoad",
          noCache: true,
        },
      },
    ],
  },
];

export default AuthorityRouter